import { useRef } from 'react'
import { DoubleArrow } from '@mui/icons-material'
import { IconButton, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import TypeFilter from '../../../../shared/components/TypeFilter'
import ScrollSubHeader from '../../../../shared/styles/ScrollSubHeader'

function ResourceTypeFilter({ filters, handleChangeFilter }: { filters: any; handleChangeFilter: any }) {
  const { t } = useTranslation(['global'])

  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { resourcecategories: categories } = useSelector((state: IRootState) => state.resourcecategory)

  const theme = useTheme()
const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
const scrollRef = useRef<HTMLDivElement | null>(null)

  const myElement: HTMLElement | null = document.getElementById('windowCourseClient')
  const midOfWidth = window.innerWidth / 2


  return (
    <>
      <ScrollSubHeader ref={isMobile ? scrollRef : null} id="window">
        {resourcetypes
          .filter((resourcetype: any) => resourcetype.id !== 4)
          .map((resourcetype: any) => (
            <TypeFilter
              key={resourcetype.id}
              id={resourcetype.id}
              type={resourcetype.name}
              categories={categories.filter((category: any) => category.resourcetype_id === resourcetype.id)}
              filterCategoryId={filters.category_id}
              active={resourcetype.id === filters.resourcetype_id}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
        <TypeFilter
          id={null}
          type={t('all')}
          categories={[]}
          active={filters.resourcetype_id === null}
          filterCategoryId={filters.category_id}
          handleChangeFilter={handleChangeFilter}
        />
      </ScrollSubHeader>
      {isMobile && (
          <IconButton
            sx={{ position: 'absolute', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }}
            className="buttonScroll"
            onClick={() => {
              myElement?.scrollBy(midOfWidth, 0)
            }}
          >
          <DoubleArrow />
        </IconButton>
      )}
    </>
  )
}

export default ResourceTypeFilter
